/* Identifies map-page tile requests to OpenStreetMap while limiting the Referer to the site origin. */
export const OSM_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export function prepareOsmTiles() {
  let policy = document.head.querySelector('meta[name="referrer"]') as HTMLMetaElement;
  if (!policy) {
    policy = document.createElement('meta');
    policy.name = 'referrer';
    document.head.appendChild(policy);
  }
  policy.content = 'strict-origin-when-cross-origin';
}
